export default __webpack_public_path__ + "static/media/ART9.e4473889.jpg";